import EmptyState from '@liquidweb-dev/undercurrent/EmptyState';

interface CancellationLoaderProps {
	icon: React.JSX.Element;
	title: string;
}

const CancellationLoader = ({ icon, title }: CancellationLoaderProps) => {
	return (
		<EmptyState
			icon={icon}
			sx={{ width: '100%', height: '152px', justifyContent: 'center' }}
		>
			{title}
		</EmptyState>
	);
};

export default CancellationLoader;
